import { getDefaultExportFromCjs as e } from "../../_virtual/_commonjsHelpers.es.js";
import { __module as r } from "../../_virtual/index.es.js";
import { __require as o } from "../react-is/index.es.js";
import { __require as t } from "./factoryWithTypeCheckers.es.js";
import { __require as p } from "./factoryWithThrowingShims.es.js";
if (process.env.NODE_ENV !== "production") {
  var s = o(), i = !0;
  r.exports = t()(s.isElement, i);
} else
  r.exports = p()();
var m = r.exports;
const q = /* @__PURE__ */ e(m);
export {
  q as default
};
//# sourceMappingURL=index.es.js.map
